import * as THREE from 'three';
import Exp from "../Exp";
import Environment from './Environment';
import Resources from '../utils/Resources';
import { Emitter } from '../../core';

export default class World {
    constructor() {
        this.experience = new Exp();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;

        //Wait for resources
        Emitter.on('resouces_Ready', () => {
            console.log('Environment map READY!')

            //Setup
            this.environment = new Environment();
        })

        console.log('The world')
    }
}